import { TAG_KEYS } from '@components/imageHandling/common';
import { RetrievedDocumentReferenceLink } from '@v2/components/imageHandling/types/types';
import { useBuildLinkListByPerspective } from './useBuildlLinkListByPerspective';

export const useBuildImageContextForAdding = (
  selectedJobId: number | undefined,
  scopeIds: (keyof typeof TAG_KEYS)[]
): Pick<RetrievedDocumentReferenceLink, 'isFavorite' | 'scopeReferenceId' | 'scopeId'>[] => {
  const allPossibleLinks = useBuildLinkListByPerspective(selectedJobId);
  return allPossibleLinks
    .filter((l) => scopeIds.includes(l.scopeId as keyof typeof TAG_KEYS))
    .map((l) => ({ scopeId: l.scopeId, scopeReferenceId: l.scopeReferenceId, isFavorite: false }));
};
